import { render } from "./DashUpload.vue?vue&type=template&id=735d7a8b"
import script from "./DashUpload.vue?vue&type=script&lang=js"
export * from "./DashUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__